import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
@Component({
  selector: 'app-input-property',
  templateUrl: './input-property.component.html',
  styleUrls: ['./input-property.component.scss']
})
export class InputPropertyComponent implements OnInit {
  private _attributes: any = [];
  public varcharAttributes: Array<any> = [];
  public inputTypes: Array<any> = [];

  @Input() component: any;
  @Input() set attributes(value: any) {
    this._attributes = value;
    if (this._attributes) {
      let defaultType = this.component.type;
      let attrTypes = ['varchar'];

      if (this.component.element.bind_to_variable) {
        for (let item of this._attributes) {
          if (item.slug === this.component.element.bind_to_variable) {
            defaultType = item.type;
            break;
          }
        }
      }

      switch (defaultType) {
        case 'date':
          attrTypes = ['date', 'varchar'];
          break;

        case 'datetime':
          attrTypes = ['datetime', 'varchar'];
          break;

        case 'number':
          attrTypes = ['integer', 'varchar'];
          break;

        default:
          attrTypes = ['varchar'];
      }

      this.varcharAttributes = _.sortBy(
        this._attributes.filter((att: any) => {
          return attrTypes.indexOf(att.type) > -1;
        }),
        ['name']
      );
    }
  }

  get attributes(): any {
    return this._attributes;
  }

  @Output() onBindVariableChange: EventEmitter<any> = new EventEmitter();

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.inputTypes = [
      {
        value: 'text',
        label: this.translate.instant('Text')
      },
      {
        value: 'email',
        label: this.translate.instant('Email')
      },
      {
        value: 'date',
        label: this.translate.instant('Date')
      },
      {
        value: 'datetime',
        label: this.translate.instant('Date - Hour')
      },
      {
        value: 'number',
        label: this.translate.instant('Number')
      }
    ];
    // Set field_name blank by default
    // if (this.component && this.component.element) {
    //   this.component.element.field_name = 'input_label';
    // }
  }

  onInputTypeChange($event: any) {
    let attrTypes = ['varchar'];

    switch ($event) {
      case 'date':
        attrTypes = ['date', 'varchar'];
        break;

      case 'datetime':
        attrTypes = ['datetime', 'varchar'];
        break;

      case 'number':
        attrTypes = ['integer', 'varchar'];
        break;

      default:
        attrTypes = ['varchar'];
    }

    this.varcharAttributes = _.sortBy(
      this.attributes.filter((att: any) => {
        return attrTypes.indexOf(att.type) > -1;
      }),
      ['name']
    );

    this.handleOnBindVariableChange('');
  }

  handleOnBindVariableChange($event: any) {
    this.onBindVariableChange.emit({
      value: $event,
      id: this.component.id
    });
  }

  onLabelChange(label: string) {
    // Update placeholder with "Enter" prefix
    this.component.element.placeholder_text = label ? `Enter ${label}` : '';
    
    // Update field name: convert to lowercase, replace spaces/special chars with underscores
    this.component.element.field_name = label
      ? label.toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')  // Replace non-alphanumeric chars with underscore
          .replace(/^_+|_+$/g, '')       // Remove leading/trailing underscores
          .replace(/_+/g, '_')           // Replace multiple underscores with single
          .substring(0, 100)             // Limit to 100 characters
      : '';
  }

    sanitizeFieldName() {
    if (this.component && this.component.element && typeof this.component.element.field_name === 'string') {
      // Only allow letters, numbers, and underscores, must start with letter or underscore
      let val = this.component.element.field_name;
      // Remove forbidden special characters ($&^#@ and others)
      val = val.replace(/[^A-Za-z0-9_]/g, '');
      // Ensure first character is letter or underscore
      if (!/^[A-Za-z_]/.test(val)) {
        val = val.replace(/^[^A-Za-z_]+/, '');
      }
      // Limit to 100 chars
      this.component.element.field_name = val.substring(0, 100);
    }
  }
  // Prevent forbidden special characters from being entered
  preventSpecialChar(event: KeyboardEvent) {
    const allowed = /^[A-Za-z0-9_]$/;
    // Allow navigation, backspace, delete, tab, arrows, home, end
    if (
      event.ctrlKey || event.metaKey ||
      [8, 9, 13, 16, 17, 18, 20, 27, 35, 36, 37, 38, 39, 40, 46].includes(event.keyCode)
    ) {
      return;
    }
    if (!allowed.test(event.key)) {
      event.preventDefault();
    }
  }

  // Filter forbidden characters on paste or input
  filterSpecialCharOnInput() {
    if (this.component && this.component.element && typeof this.component.element.field_name === 'string') {
      let val = this.component.element.field_name;
      val = val.replace(/[^A-Za-z0-9_]/g, '');
      // Ensure first character is letter or underscore
      if (!/^[A-Za-z_]/.test(val)) {
        val = val.replace(/^[^A-Za-z_]+/, '');
      }
      this.component.element.field_name = val.substring(0, 100);
    }
  }
}